module.exports = __webpack_public_path__ + "img/lema-logo-color.749af4bb.svg";